import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../image/jmif_logo2.svg";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const [dropdownHovered, setDropdownHovered] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleDropdownClick = (index, item) => {
    if (item.dropdown) {
      // setDropdownVisible(!dropdownVisible);
      setDropdownVisible(dropdownVisible === index ? null : index);
    } else {
      navigate(item.to);
    }

    // setDropdownVisible(dropdownVisible === index ? null : index);
  };

  const isMobile = window.innerWidth < 1024;
  useEffect(() => {
    if (dropdownVisible) {
      return;
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(!dropdownVisible);
      }
    };

    window.addEventListener("mouseup", handleClickOutside);

    return () => {
      window.removeEventListener("mouseup", handleClickOutside);
    };
  }, [dropdownVisible]);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  const navPath = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    {
      to: "/academics",
      label: "Academics",
      dropdown: [
        { to: "/academics/basic-education", label: "Basic Education" },
        { to: "/academics/tertiary-education", label: "Tertiary Education" },
      ],
    },
    { to: "/admission", label: "Admission" },
    // { to: "/alumni", label: "Alumni" },
    { to: "/contactUs", label: "Contact Us" },
  ];
  return (
    <div className="sticky top-0 w-full z-50 ">
      <div className="relative">
        {/* logo */}
        <div className="absolute laptop:ml-0 md:ml-8 lg:w-[75px] w-[68px] h-[116px] mobileLg:h-[105px] lg:h-full  bg-secondary-normal top-0 laptop:left-[144px] mobileSm:left-8 left-4 z-50 flex justify-center items-center  ">
          <div className=" mt-14 mobileLg:mt-8 ">
            <img
              src={logo}
              alt="logo"
              className="lg:w-[65px] lg:h-[65px] w-[55px] h-[55px]"
            />
          </div>{" "}
        </div>
        {/* triangle */}
        <div className="absolute laptop:ml-0 md:ml-8 lg:top-[108px] top-28 mobileLg:top-[101px] laptop:left-[140px] mobileSm:left-[27.5px] left-3 z-40 lg:block ">
          <svg
            // width="83"
            // height="46"
            viewBox="0 0 83 46"
            fill="none"
            className="lg:w-[83px] lg:h-[46px] w-[76.4px] h-[42px]"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_175_199)">
              <path
                d="M38.8667 36.6969C40.3745 38.0157 42.6255 38.0157 44.1333 36.6969L77.2182 7.7609C79.9987 5.32908 78.2787 0.75 74.5848 0.75H8.41519C4.72128 0.75 3.00134 5.32908 5.78184 7.7609L38.8667 36.6969Z"
                fill="#F7AACA"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_175_199"
                x="0.407166"
                y="0.75"
                width="82.1857"
                height="44.936"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_175_199"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_175_199"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        {/* Banner For contact information */}
        <div className="flex items-end gap-y-0 mobileLg:justify-end flex-col mobileLg:flex-row responsive-padding py-2 bg-grey-darker gap-4 text-white font-notoSans font-light text-[10px] relative ">
          <a
            href="mailto:jamiatumarawi2000@gmail.com"
            className="flex gap-x-2 items-center w-auto"
          >
            {" "}
            <svg
              width="20"
              height="16"
              viewBox="0 0 20 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.30775 15.5C1.80258 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80258 19.5 2.30775V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.30775ZM10 8.55775L2 3.44225V13.6923C2 13.7821 2.02883 13.8558 2.0865 13.9135C2.14417 13.9712 2.21792 14 2.30775 14H17.6923C17.7821 14 17.8558 13.9712 17.9135 13.9135C17.9712 13.8558 18 13.7821 18 13.6923V3.44225L10 8.55775ZM10 7L17.8463 2H2.15375L10 7ZM2 3.44225V2V13.6923C2 13.7821 2.02883 13.8558 2.0865 13.9135C2.14417 13.9712 2.21792 14 2.30775 14H2V3.44225Z"
                fill="#E8EBE9"
              />
            </svg>
            <span>jamiatumarawi2000@gmail.com </span>{" "}
          </a>
          <div className="flex gap-x-2 items-center w-auto">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4402 17.5C14.5557 17.5 12.6625 17.0618 10.7605 16.1855C8.85867 15.3092 7.11125 14.073 5.51825 12.477C3.92542 10.8808 2.69083 9.13333 1.8145 7.2345C0.938167 5.33583 0.5 3.44425 0.5 1.55975C0.5 1.25692 0.6 1.00458 0.8 0.80275C1 0.600916 1.25 0.5 1.55 0.5H4.8115C5.064 0.5 5.28675 0.582417 5.47975 0.74725C5.67275 0.911917 5.7955 1.11542 5.848 1.35775L6.42125 4.3C6.46092 4.573 6.45258 4.80758 6.39625 5.00375C6.33975 5.19992 6.23842 5.36467 6.09225 5.498L3.78275 7.74625C4.15442 8.42692 4.57908 9.07083 5.05675 9.678C5.53425 10.285 6.05125 10.8648 6.60775 11.4173C7.15642 11.9661 7.73975 12.4757 8.35775 12.9462C8.97575 13.4167 9.64308 13.8546 10.3598 14.2598L12.6038 11.9963C12.7603 11.8334 12.9498 11.7193 13.1723 11.6538C13.3946 11.5884 13.6257 11.5724 13.8655 11.6058L16.6423 12.1713C16.8948 12.2379 17.1008 12.3667 17.2605 12.5577C17.4202 12.7487 17.5 12.9654 17.5 13.2078V16.45C17.5 16.75 17.3991 17 17.1973 17.2C16.9954 17.4 16.7431 17.5 16.4402 17.5ZM3.073 6.327L4.85775 4.61925C4.88975 4.59358 4.91058 4.55833 4.92025 4.5135C4.92992 4.46867 4.92833 4.427 4.9155 4.3885L4.48075 2.15375C4.46792 2.10258 4.4455 2.06417 4.4135 2.0385C4.3815 2.01283 4.33983 2 4.2885 2H2.15C2.1115 2 2.07942 2.01283 2.05375 2.0385C2.02825 2.06417 2.0155 2.09625 2.0155 2.13475C2.06667 2.81808 2.1785 3.51225 2.351 4.21725C2.52333 4.92242 2.764 5.62567 3.073 6.327ZM11.773 14.9693C12.4358 15.2783 13.1272 15.5145 13.847 15.678C14.567 15.8413 15.2397 15.9384 15.8652 15.9693C15.9037 15.9693 15.9358 15.9564 15.9615 15.9307C15.9872 15.9051 16 15.873 16 15.8345V13.7308C16 13.6794 15.9872 13.6377 15.9615 13.6058C15.9358 13.5738 15.8974 13.5513 15.8462 13.5385L13.7462 13.1115C13.7077 13.0987 13.6741 13.0971 13.6453 13.1067C13.6164 13.1164 13.5859 13.1372 13.5538 13.1692L11.773 14.9693Z"
                fill="#E8EBE9"
              />
            </svg>
            <span>+639771964178</span>
          </div>
        </div>
        {/* navbar */}
        <div
          className={`w-full lg:h-20 bg-alternative-light flex lg:flex-row flex-col lg:justify-between laptop:px-36 lg:pr-16 lg:pl-40 items-center shadow-custom
            ${openMenu ? "h-full" : ""}`}
        >
          {/* jmif name */}
          <div className="flex justify-between items-center  laptop:ml-[95px] w-full lg:w-auto lg:shadow-none shadow-custom lg:px-0 md:pr-16 mobileSm:pr-8 pr-4 md:pl-40 ">
            <span className="uppercase font-lateef text-[45px] text-text-normal ml-[45%] md:ml-0">
              JMIF
            </span>{" "}
            <div className="lg:hidden" onClick={toggleMenu}>
              {openMenu ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.4 13.6537L0.346252 12.5999L5.94625 6.99994L0.346252 1.39994L1.4 0.346191L7 5.94619L12.6 0.346191L13.6538 1.39994L8.05375 6.99994L13.6538 12.5999L12.6 13.6537L7 8.05369L1.4 13.6537Z"
                    fill="#1C1B1F"
                  />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 18 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5 11.6347V10.135H17.5V11.6347H0.5ZM0.5 6.75022V5.25022H17.5V6.75022H0.5ZM0.5 1.86547V0.365723H17.5V1.86547H0.5Z"
                    fill="#1C1B1F"
                  />
                </svg>
              )}
            </div>
          </div>
          {/* Navigation rows */}
          <div
            className={`w-full flex-col  lg:flex  lg:flex-row lg:items-center lg:justify-between gap-x-5 font-montserrat font-semibold text-sm ${
              openMenu ? "block  pl-0" : "hidden lg:block lg:w-auto"
            }`}
          >
            {navPath.map((item, index) => (
              <div
                key={index}
                className={`lg:w-auto  laptopSm:bg-alternative-light hover:bg-text-lightActive laptopSm:hover:bg-alternative-light
                   text-text-light hover:text-text-normal laptopSm:text-[#1A1919] 
                    ${
                      item.to === "/"
                        ? location.pathname === "/"
                          ? "text-text-normal bg-text-lightActive"
                          : "bg-text-normal"
                        : location.pathname.includes(item.to)
                        ? "text-text-normal bg-text-lightActive"
                        : "bg-text-normal"
                    }           
                     ${
                       dropdownVisible === index
                         ? "text-text-normal bg-text-lightActive"
                         : ""
                     }

                     `}
                onClick={() => handleDropdownClick(index, item)}
              >
                <div className="flex justify-center relative  py-4 ">
                  <Link
                    to={item.to}
                    className={`hover:text-text-normal laptopSm:border-b-2   hover:border-text-normal 
                       ${
                         item.to === "/"
                           ? location.pathname === "/"
                             ? "laptopSm:text-text-normal    border-text-normal stroke-text-normal "
                             : " border-alternative-light"
                           : location.pathname.includes(item.to)
                           ? "laptopSm:text-text-normal  laptopSm:border-b-2  border-text-normal stroke-text-normal "
                           : "border-alternative-light"
                       }
               
                `}
                  >
                    {item.label}
                  </Link>
                  {item.dropdown && (
                    <svg
                      onClick={() => handleDropdownClick(index, item)}
                      className={`ml-1 hover:text-text-normal cursor-pointer 
                       `}
                      width="25"
                      height="23"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onMouseEnter={() => setDropdownHovered(true)}
                      onMouseLeave={() => setDropdownHovered(false)}
                      style={{
                        stroke:
                          dropdownHovered ||
                          dropdownVisible === index ||
                          location.pathname.includes(item.to)
                            ? "#19733b"
                            : "#1A1919",
                        transition: "stroke 0.3s",
                      }}
                    >
                      <path
                        d="M6.5 9L12.5 15L18.5 9"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}

                  {/* desktop dropdown */}
                  {dropdownVisible === index && !isMobile && (
                    <div
                      className=" absolute   left-[-10px] mt-10 min-w-48 bg-[#FDF1FA] z-50 laptopSm:block hidden "
                      ref={dropdownRef}
                    >
                      {item.dropdown.map((item, index) => (
                        <Link
                          key={`${item.label}-${index}`}
                          to={item.to}
                          className="block px-4 py-3 text-nowrap "
                        >
                          <p
                            className={`hover:text-text-normal text-[#1A1919] hover:border-b-2 hover:border-text-normal w-auto pb-1
                                   ${
                                     location.pathname === item.to
                                       ? "laptopSm:text-text-normal  laptopSm:border-b-2  border-text-normal stroke-text-normal "
                                       : ""
                                   }
                              `}
                          >
                            {item.label}
                          </p>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>

                {dropdownVisible === index && isMobile && (
                  <div
                    className={`bg-[#FDF1FA] text-center  laptopSm:hidden block
                          ${
                            location.pathname === item.to
                              ? "text-text-normal bg-text-lightActive"
                              : "bg-text-normal"
                          }
                      `}
                  >
                    {item.dropdown.map((item, index) => (
                      <Link
                        key={`${item.label}-${index}`}
                        to={item.to}
                        className={`    ${
                          location.pathname === item.to
                            ? "text-text-normal bg-text-lightActive"
                            : "bg-text-normal"
                        } block px-4 py-2 hover:bg-text-lightActive hover:text-text-normal  text-text-light`}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
